export const hasDepositCheckRequests = (requests) =>
  Array.isArray(requests) && requests.length > 0;
